import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../config";
import axiosClient from "../../common/api/request";

export const getIntegretionSetting = createAsyncThunk(
  "getIntegretionSetting",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/integration_settings/`,
        { params },
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        // [CANA-589] the status lets General Settings tell a 403 (no
        // view_integrationsetting) apart from a validation body.
        return rejectWithValue({
          ...error.response.data,
          status: error.response.status,
        });
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const updateInterationSetting = createAsyncThunk(
  "updateInterationSetting",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.patch(
        `${config.API_URL}/integration_settings/${params.id}/`,
        params,
        config
      );
      return data;
    }  catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
